var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProfile = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#DADEFB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 16,
    r: 6,
    fill: "#4a4a4a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8992 24H17.1008C15.3124 24 13.5709 24.5718 12.1306 25.6319C11.1023 26.3887 11.164 27.9496 12.2375 28.641C13.607 29.5229 15.214 30 16.8429 30H23.1571C24.786 30 26.393 29.5229 27.7625 28.641C28.836 27.9496 28.8977 26.3887 27.8694 25.6319C26.4291 24.5718 24.6876 24 22.8992 24Z",
    fill: "#4a4a4a"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProfile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/profile.d2eade5aee82a9f013cbb42df350adb6.svg";